export default __webpack_public_path__ + "static/media/eb-clatter.e810047e.svg";